import { css, Theme } from '@emotion/react'

export const container = css`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const title = css`
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`

export const hr = (theme: Theme) => css`
  height: 1px;

  background-color: ${theme.colors.backgroundOne};
`

export const optionWrapper = css`
  display: flex;
  column-gap: 8px;
  align-items: center;
`

export const iconWrapper = (color: string) => (theme: Theme) =>
  css`
    display: flex;
    align-items: center;
    justify-content: center;

    width: 22px;
    height: 22px;
    border-radius: 4px;

    background-color: ${color};

    color: ${theme.colors.white};
  `
